import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Alert,
  Container,
  IconButton
} from '@mui/material';
import {
  WifiOff as OfflineIcon,
  Refresh as RefreshIcon,
  Close as CloseIcon
} from '@mui/icons-material';

const OfflineNotification = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOfflineAlert(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineAlert(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Show alert if already offline
    if (!navigator.onLine) {
      setShowOfflineAlert(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    setShowOfflineAlert(false);
  };

  if (!showOfflineAlert) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 16,
        left: 16,
        right: 16,
        zIndex: 9999,
        pointerEvents: 'none'
      }}
    >
      <Alert
        severity="warning"
        icon={<OfflineIcon />}
        sx={{
          pointerEvents: 'auto',
          '& .MuiAlert-action': {
            padding: 0
          }
        }}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              onClick={handleRefresh}
              startIcon={<RefreshIcon />}
              sx={{ mr: 1 }}
            >
              إعادة المحاولة
            </Button>
            <IconButton
              size="small"
              onClick={handleDismiss}
              color="inherit"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        }
      >
        لا يوجد اتصال بالإنترنت. بعض الميزات قد لا تعمل بشكل صحيح.
      </Alert>
    </Box>
  );
};

export default OfflineNotification;
